import React from "react"
import IntroSection from "../UI/IntroSection"
import InfoWithImageSection from "../UI/InfoWithImageSection"
import BenefitsSection from "./BenefitsSection"
import CTA from "../UI/CTA"

const ConsorcioDesktop: React.FC = () => {
    return (
        <main>
            <IntroSection title="Consórcio Azul Agro" text="O consórcio que garante a melhor produção da sua lavoura" img="https://gabcomercio.azureedge.net/azul-agro/desktop/consorcio/introSection.webp" alignItems="flex-start" justifyContent="flex-end" lineInverted />
            <CTA href="/consorcio/contato" text="Quer saber mais sobre o Consórcio Azul Agro?" />
            <InfoWithImageSection title={"O consórcio que garante a melhor produção para sua lavoura!"} text={"Sabemos que investir em equipamento, exige planejamento. Por isso, temos várias opções de planos para atender à sua necessidade. No Consórcio New Holland, você pode escolher o melhor prazo e o valor da parcela que cabe no seu orçamento."} img={"https://gabcomercio.azureedge.net/azul-agro/general/consorcio/img1.webp"} width={530} height={600} />
            <BenefitsSection width={400} isDesktop />
            <InfoWithImageSection title={"Planeje o seu negócio com o Consórcio Azul Agro"} text={"Com o Consórcio Azul Agro, planeje seu maquinário de acordo com a sua safra, e aproveite as formas de pagamento flexíveis no Consórcio New Holland com a Azul Agro."} img={"https://gabcomercio.azureedge.net/azul-agro/general/consorcio/img2.webp"} width={530} height={600} hasButton href="/consorcio/contato" />
        </main>
    )
}

export default React.memo(ConsorcioDesktop)
